// extracted by mini-css-extract-plugin
export default {"loading":"WkQblpAE99BlFnv2ZMqI","top-pane":"xeVWMH6iIaIZUlXijOWQ","title-txt":"h_rVXC5kJcHVdDrA3Roz","center-pane":"r1prvbRDHfvKuF9CAnmq"};